import styled, { css } from 'styled-components';
import { Container as ContainerColumnLabel } from '@/main/components/common/columnLabel/styles';

interface IContainerProps {
  $hasExpand?: boolean;
}
export const ContainerRow = styled.div<IContainerProps>`
  width: 100%;
  overflow: auto;

  ${({ $hasExpand, theme }) =>
    $hasExpand &&
    css`
      border: 1px solid ${theme.pantone2190C};
      border-radius: 4px;
    `};
`;

export const WrapperContainer = styled.div`
  overflow: auto;
`;
const COLUMNS_ROW_GRID = 6;
interface IContainerProps {
  $numbersColumnsHidden?: number;
}
export const Container = styled.div<IContainerProps>`
  display: grid;
  grid-template-columns: ${({ $numbersColumnsHidden }) =>
    `repeat(${
      COLUMNS_ROW_GRID - ($numbersColumnsHidden ?? 0)
    }, minmax(100px, 1fr)) 100px 30px`};

  justify-items: start;
  align-items: center;
  grid-auto-flow: column;
  grid-gap: 0.6rem;
  padding: 0.4rem 1rem;
  background: ${({ theme }) => theme.white};
  border: 1px solid ${({ theme }) => theme.grayDark};
  border-radius: 4px;
  cursor: pointer;
  min-width: 960px;
  width: 100%;
  transition: background 0.3s ease-out;

  &:hover {
    background: ${({ theme }) => theme.hoverGray};
  }
  > ${ContainerColumnLabel} {
    width: inherit;
  }

  p {
    margin: 0;
  }
`;

export const ContainerTooltipDetails = styled.div`
  padding: 0.5rem;
  background: ${({ theme }) => theme.grayDark};
  min-width: 600px;
`;

export const ContainerDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
  background: ${({ theme }) => theme.white};
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  background: ${({ theme }) => theme.white};
`;

export const TextQuoteAndOrder = styled.h6`
  font-weight: bold;
  margin: 0;
`;
export const TextColumnLabel = styled.p`
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: auto;
  max-width: 200px;
`;

export const ContainerQuoteAndOrder = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.grayDark};
  border-radius: 8px;
  padding: 0.8rem;
  cursor: pointer;
  transition: background 0.3s ease-out;

  p {
    margin: 0;
  }
  &:hover {
    background: ${({ theme }) => theme.hoverGray};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
    text-align: center;
  }
`;

export const ColumnClaim = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

